<template>
  <div class="lookClass_box">
    <el-dialog
      title="看课信息"
      :visible.sync="dialogVisible"
      width="1100px"
      :before-close="handleClose"
    >
      <div v-loading="loading">
        <div class="title">看课概览</div>
        <el-table border stripe :data="roughlyData" style="width: 100%">
          <el-table-column label="学员手机号" width="170" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.phone || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="微信昵称" width="190" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.nickName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="微信头像" width="160" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.avatar">
                <el-image
                  style="width: 60px; height: 60px"
                  :src="row.avatar"
                  :preview-src-list="[row.avatar]"
                >
                </el-image>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="学习总时长" align="center">
            <template slot-scope="{ row }">
              <span>{{ handleDuration(row.duration) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开始学习时间" width="180" align="center">
            <template slot-scope="{ row }">
              <span>{{ handleJoinTime(row.joinTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="注册时间" width="180" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.insertDate || "--" }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="title">看课记录</div>
        <el-table border stripe :data="recordData" style="width: 100%">
          <el-table-column type="index" label="序号" width="110" align="center">
          </el-table-column>
          <el-table-column label="公开课名称" minWidth="220" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.openClassName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="视频名称" minWidth="220" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.videoName || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="观看时长" minWidth="180" align="center">
            <template slot-scope="{ row }">
              <span>{{ handleDuration(row.duration) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="观看时间" minWidth="180" align="center">
            <template slot-scope="{ row }">
              <span>{{ handleJoinTime(row.joinTime) }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <my-pagination
          :page-info="pageInfo"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserProgress,
  getUserRecordList,
} from "@/api/videoReference/user.js";
import myPagination from "@/components/myPagination.vue";
export default {
  components: {
    myPagination,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      roughlyData: [],
      recordData: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      userId: "",
      clueId: ""
    };
  },
  methods: {
    handleJoinTime(payload) {
      const date = new Date(Number(payload));
      let year = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let h = date.getHours();
      let f = date.getMinutes();
      let s = date.getSeconds();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      f = f < 10 ? "0" + f : f;
      s = s < 10 ? "0" + s : s;
      return `${year}-${m}-${d} ${h}:${f}:${s}`;
    },
    handleDuration(payload) {
      let time = Math.floor(payload / 3600);
      let minute = Math.floor(payload / 60 % 60);
      let second = payload % 60;
      if(time > 0){
        return `${time}小时${minute}分钟${second}秒`;
      }
      return `${minute}分钟${second}秒`;
    },
    init(payload) {
      this.roughlyData = [];
      this.recordData = [];
      this.userId = payload?.userId || "";
      this.clueId = payload?.id || "";
      this.getUserProgress();
      this.getUserRecordList({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    async getUserProgress() {
      const res = await getUserProgress({ clueId: this.clueId });
      this.roughlyData = [res.data?.data] || [];
    },
    async getUserRecordList(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getUserRecordList({ ...payload, userId: this.userId });
      this.recordData = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getUserRecordList({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getUserRecordList({ page: 1, limit: payload });
    },
  },
};
</script>

<style lang="scss" scoped>
.lookClass_box {
  ::v-deep.el-dialog__body {
    padding: 0px 20px 30px;
  }
  .title {
    font-size: 16px;
    margin: 20px 0 6px;
  }
}
</style>